import cx from "classnames";
import { SquareSpinner } from "common/spinners";
import React from "react";
import styles from "./BlockLoading.scss";

export const BlockLoading = ({ height, width, children, className, getRef }) => (
  <div className={cx(styles.BlockLoading, className)} ref={getRef} style={{ height, width }}>
    <SquareSpinner size={40} />
    {children}
  </div>
);
